<template>
  <modal v-bind="$attrs"
         v-on="$listeners"
         :title="isEdit ? $t('address.edit') : $t('address.add')">
    <form @submit.prevent="onSubmit" autocomplete="off">
      <div class="w-full">
        <fg-input :placeholder="$t('generic.address')"
                  :label="$t('generic.address')"
                  :name="$t('generic.address')"
                  :error="getError($t('generic.address'))"
                  type="text"
                  autocomplete="off"
                  addon-left-icon="nc-icon nc-pin-3"
                  required
                  v-validate="modelValidations.address_line_1"
                  v-model="model.address_line_1">
        </fg-input>
      </div>
      <div class="w-full">
        <fg-input :name="$t('generic.postalCode')"
                  :error="getError($t('generic.postalCode'))"
                  :label="$t('generic.postalCode')"
                  :placeholder="$t('generic.postalCode')"
                  required
                  v-validate="modelValidations.postal_code"
                  v-model="model.postal_code">
        </fg-input>
      </div>
      <div class="w-full">
        <fg-input :name="$t('generic.city')"
                  :placeholder="$t('generic.city')"
                  :label="$t('generic.city')"
                  :error="getError($t('generic.city'))"
                  required
                  v-validate="modelValidations.city"
                  v-model="model.city">
        </fg-input>
      </div>
      <div class="w-full">
        <fg-input :label="$t('generic.country')"
                  :error="getError($t('generic.country'))">
          <country-autocomplete v-model="model.country_code"
                                autocomplete="off"
                                @country-change="onCountryChange"
                                :name="$t('generic.country')"
                                :placeholder="$t('generic.country')"
                                required
                                v-validate="modelValidations.country">
          </country-autocomplete>
        </fg-input>
      </div>
      <dl class="rounded overflow-hidden mt-6 mb-4">
        <div class="list-row bg-gray-50">
          <dt class="list-row-dt">
            {{$t(`generic.financial`)}}
          </dt>
          <dd class="list-row-dd">
            <base-switch v-model="model.financial"/>
          </dd>
        </div>
        <div class="list-row bg-white">
          <dt class="list-row-dt">
            {{$t(`generic.delivery`)}}
          </dt>
          <dd class="list-row-dd">
            <base-switch v-model="model.delivery"/>
          </dd>
        </div>
        <div v-if="isEdit" class="list-row bg-gray-50">
          <dt class="list-row-dt">
            {{$t(`generic.primary`)}}
          </dt>
          <dd class="list-row-dd">
            <base-switch v-model="model.primary"/>
          </dd>
        </div>
      </dl>
      <div class="w-full flex justify-center mt-6">
        <submit-button :loading="loading" native-type="submit"/>
      </div>
    </form>
  </modal>
</template>
<script>
  import get from 'lodash/get'
  import CountryAutocomplete from 'src/components/Autocomplete/CountryAutocomplete'

  export default {
    inheritAttrs: false,
    components: {
      CountryAutocomplete
    },
    props: {
      data: {
        type: Object,
        default: () => ({})
      },
      loading: Boolean,
    },
    data () {
      return {
        model: {
          address_line_1: '',
          address_line_2: '',
          city: '',
          country: '',
          postal_code: '',
          country_code: '',
          label: '',
          financial: null,
          primary: null,
          delivery: null,
        }
      }
    },
    computed: {
      isEdit () {
        return this.data && this.data.id
      },
      modelValidations () {
        return {
          city: {
            required: true,
          },
          country: {
            required: true,
          },
          country_code: {
            required: true,
          },
          postal_code: {
            required: true,
          },
          address_line_1: {
            required: true,
          }
        }
      }
    },
    methods: {
      onCountryChange(data) {
        this.model.country = get(data, 'name', null)
      },
      async onSubmit () {
        let res = await this.$validator.validateAll()
        if (!res) {
          return
        }
        this.model.label = this.model.address_line_1
        this.$emit('submit', this.model)
      }
    },
    watch: {
      data: {
        immediate: true,
        handler (data) {
          if (!data) {
            return
          }
          this.model = {
            ...this.model,
            ...data
          }
        }
      }
    }
  }
</script>
<style>
</style>
